import React from 'react';
import isEmpty from 'ramda/src/isEmpty';
import isNil from 'ramda/src/isNil';
import not from 'ramda/src/not';
import { ArticleAdviceAnswer, ArticleAdviceAnswerValue } from '../ArticleAdviceAnswer';
import { ArticleAdviceCard } from '../ArticleAdviceCard';
import { ArticleAdviceCardActions, ArticleAdviceCardActionsProps } from '../ArticleAdviceCardActions';
import { ArticleAdviceCardHeader, ArticleAdviceCardHeaderValue } from '../ArticleAdviceCardHeader';
import { ArticleAdviceQuestion, ArticleAdviceQuestionValue } from '../ArticleAdviceQuestion';
import { ArticleAdviceResponses, ArticleAdviceResponsesValue } from '../ArticleAdviceResponses';
import { Container } from '../Container';
import { SymptomList, SymptomListValue } from '../SymptomList';
import { Divider } from '../../wag-react/core-components/divider';
import { theme } from '../../wag-react/themes/base-theme';
export type HealthArticleSectionAdviceValue = {
  answer: ArticleAdviceAnswerValue;
  header: ArticleAdviceCardHeaderValue;
  id: number;
  question: ArticleAdviceQuestionValue;
  responses: ArticleAdviceResponsesValue;
  symptoms: SymptomListValue;
  // The package `schema-dts` causes us some memory heap issues
  // https://github.com/google/schema-dts/issues/34
  // We will now be removing it and using the `unknown` type
  // Documentation here https://blog.logrocket.com/when-to-use-never-and-unknown-in-typescript-5e4d6c5799ad/
  // TODO - We should this properly type this in the future something like `schema-dts`
  structuredData: unknown;
};
type Props = ArticleAdviceCardActionsProps & {
  value: HealthArticleSectionAdviceValue;
};
const hasNoAnswer = (answer: ArticleAdviceAnswerValue) => isEmpty(answer) || isNil(answer);
const hasResponses = (responses: ArticleAdviceResponsesValue) => not(isEmpty(responses));
export const HealthArticleSectionAdvice = ({
  value: {
    answer,
    header,
    question,
    responses,
    symptoms
  },
  onClickNo,
  onClickYes
}: Props) => <ArticleAdviceCard data-sentry-element="ArticleAdviceCard" data-sentry-component="HealthArticleSectionAdvice" data-sentry-source-file="index.tsx">
    <ArticleAdviceCardHeader value={header} data-sentry-element="ArticleAdviceCardHeader" data-sentry-source-file="index.tsx" />

    <Container p={['16px', '24px']} data-sentry-element="Container" data-sentry-source-file="index.tsx">
      {!!symptoms?.length && <SymptomList value={symptoms} />}
      <ArticleAdviceQuestion value={question} data-sentry-element="ArticleAdviceQuestion" data-sentry-source-file="index.tsx" />
    </Container>

    {/* Only show the divider if there's no answer and have responses */}
    {hasNoAnswer && hasResponses(responses) && <Container>
        <Divider />
      </Container>}

    {answer && <ArticleAdviceAnswer value={answer} />}

    <ArticleAdviceResponses value={responses} data-sentry-element="ArticleAdviceResponses" data-sentry-source-file="index.tsx" />

    <Container display={['block', 'flex']} alignItems="center" justifyContent="space-between" backgroundColor={theme.colors.whiteSmoke} py="32px" data-sentry-element="Container" data-sentry-source-file="index.tsx">
      <ArticleAdviceCardActions onClickYes={onClickYes} onClickNo={onClickNo} data-sentry-element="ArticleAdviceCardActions" data-sentry-source-file="index.tsx" />
    </Container>
  </ArticleAdviceCard>;